// CREATE CARD
export const CREATE_CARD_REQUEST = "CARD.CREATE_CARD_REQUEST";
export const CREATE_CARD_SUCCESS = "CARD.CREATE_CARD_SUCCESS";
export const CREATE_CARD_FAILURE = "CARD.CREATE_CARD_FAILURE";

// GET LIST OF CARDS
export const GET_LIST_REQUEST = "CARDS.GET_LIST_REQUEST";
export const GET_LIST_SUCCESS = "CARDS.GET_LIST_SUCCESS";
export const GET_LIST_FAILURE = "CARDS.GET_LIST_FAILURE";

// GET RANDOM CARD
export const GET_SINGLE_REQUEST = "CARDS.GET_SINGLE_REQUEST";
export const GET_SINGLE_SUCCESS = "CARDS.GET_SINGLE_SUCCESS";
export const GET_SINGLE_FAILURE = "CARDS.GET_SINGLE_FAILURE";

// GET RANDOM CARD
export const GET_RANDOM_REQUEST = "CARDS.GET_RANDOM_REQUEST";
export const GET_RANDOM_SUCCESS = "CARDS.GET_RANDOM_SUCCESS";
export const GET_RANDOM_FAILURE = "CARDS.GET_RANDOM_FAILURE";

// REMOVE CARD
export const REMOVE_CARD = "CARDS.REMOVE_CARD";
